import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject, takeUntil } from 'rxjs';
import { modifiedTimer } from 'src/app/utilities/ZoneUtils';
import { IconTypes } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import {
  ModalTemplateComponent,
  PencilModalSizeEnum,
} from 'src/app/standalones/components/modals/modal-template/modal-template.component';
import { PencilButtonComponent } from 'src/app/standalones/components/pencil-button/pencil-button.component';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

export interface SpeedbumpModalData {
  title: string;
  body: { main: string };
  controls: { icon: string; text: string; isSvg?: boolean }[];
  bodyMainTimeoutSeconds?: number;
}
@UntilDestroy()
@Component({
  selector: 'app-speedbump-modal',
  templateUrl: './speedbump-modal.component.html',
  styleUrls: ['./speedbump-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ModalTemplateComponent, PencilButtonComponent],
})
export class SpeedbumpModalComponent {
  public _bodyMain$ = new Subject<string>();
  dialogInputData: SpeedbumpModalData;
  readonly pencilModalSizeEnum = PencilModalSizeEnum;
  constructor(
    private dialogRef: MatDialogRef<SpeedbumpModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: SpeedbumpModalData,
    private translateService: TranslateService,
  ) {
    this.dialogInputData = data;
    if (this.dialogInputData.bodyMainTimeoutSeconds) {
      this.handleBodyMainHasTimedValues(this.dialogInputData.bodyMainTimeoutSeconds);
    }
  }

  close(option: boolean) {
    this.dialogRef.close(option);
  }

  private handleBodyMainHasTimedValues(timeout: number) {
    const timeoutAfter$ = modifiedTimer((timeout - 1) * 1000);
    const originalBodyMain = this.dialogInputData.body.main;
    modifiedTimer(0, 1000)
      .pipe(untilDestroyed(this), takeUntil(timeoutAfter$))
      .subscribe(() => {
        timeout--;
        const timeUnit = timeout === 1 ? this.translateService.instant('second') : this.translateService.instant('seconds');
        const bodyMain = originalBodyMain
          .replace(/\{timeout\}/g, String(timeout))
          .replace(/\{timeUnit\}/g, timeUnit);
        this._bodyMain$.next(bodyMain);
      });
  }
  protected IconTypes = IconTypes;
}
